import {EventEmitter, Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {Amenity} from '../types/models';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {ConstantsService} from './constants.service';
import {AccountPermissionsService} from './account-permissions.service';
import {ResidentService} from './resident.service';
import {AuthenticationService} from './authentication.service';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';
import {filter, map, tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const toastr: any;
declare const swal: any;
declare const $: any;
declare const moment: any;

@Injectable()
export class AmenitiesService {
    view = 'calendar';
    isAmenityModalShow = false;
    isAmenityViewShow = false;
    isAmenityPaymentShow = false;
    isAmenityDepositChargeShow = false;
    isPrefilledFromDirectory = false;
    isDisabledDateModalShown = false;
    showDetailedView = false;

    amenityInAmenityModal: Amenity;

    data = {
        allAmenities: {
            get: '/v1/booking_list.json?expand=amenity,building,suite,resident,createdBy,notes,notes.createdBy,payments,payments.transactions,payments.transactions.createdBy,event',
            data: [],
            total: null
        },
    };
    tabId = 'allAmenities';
    spinnerShow = true;
    showServiceUnavailable = false;
    buildings: Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    eventsForCalendar: Array<any> = [];
    serviceName: string = 'amenity';
    amenitiesList = [];
    amenitiesByBuilding = [];
    eventsByBuilding = [];
    amenitiesListForModal = [];
    modalAmenitiesLoadingSpinnerShow = false;
    calendarSpinnerShow = false;
    calendarBookings = [];
    calendarViewRequestSubscription = null;
    monthsArray: Array<string> = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    arrayOfMonthsLastDays: Array<number> = [
        31,
        new Date().getFullYear() % 4 == 0 ? 29 : 28,
        31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    prefilledDateFromCaledar = '';
    calendarDisabledDatesSubscription = null;
    disabledDatesArray = [];
    hiddenBookingsSubscription = null;
    firstTimeLoading = true;
    selectedItemData: any;
    historyLoading = false;
    history = [];
    onDetailedViewToggle: EventEmitter<any> = new EventEmitter();
    onPaymentTableAction: EventEmitter<any> = new EventEmitter();
    showQuoteModal = false;
    quoteModalType = '';
    quoteModalObject = null;
    selectedDisabledDate: any;

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
        public account: AccountPermissionsService,
        private residentService: ResidentService,
        private authenticationService: AuthenticationService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }
    static FixToQueryTO = null;
    getData(scrollToTop?) {
        clearTimeout(AmenitiesService.FixToQueryTO);
        AmenitiesService.FixToQueryTO = setTimeout(_ => {
            this.getDataByQueryParams(scrollToTop).subscribe();
        }, 300);
    }

    getDataByQueryParams(scrollToTop?) {
        this.showServiceUnavailable = false;
        this.spinnerShow = true;
        this.data[this.tabId].total = null;
        const tabId = this.urlService.queryParams['tab'];
        const url = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();

        const resident = this.authenticationService.userIsResident;
        const selectedBuilding = JSON.parse(localStorage.getItem('residentselectedBuilding'));
        let sortedDateResident = '';
        if (resident && selectedBuilding) {
            sortedDateResident = `&building_id=${selectedBuilding.buildingId}&suite_id=${selectedBuilding.suite_id}`;
        } else if (resident && !selectedBuilding) {
            return of(null);
        }
        return this.api.getJson('domainAmenities', `${url}${queryParams}${resident ? sortedDateResident : ''}`)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity((entity: any) => {
                    if (entity.building && entity.building.bdId) {
                        entity.building.id = entity.building.bdId;
                    }
                    return Amenity.fromBookingData(this.account.addPermissionsToEntity(entity, this.serviceName));
                }),
                tap(response => this.spinnerShow = !response.finished),
                tap(
                    body => {
                        this.data[tabId].data = body.entities;
                        this.data[tabId].total = body.total;
                    }
                ),
                tap(
                    () => {
                        if ($('.table')[0] && scrollToTop)
                            $('.table')[0].scrollIntoView();
                    },
                    (error) => {
                        this.spinnerShow = false;
                        this.showServiceUnavailable = true;
                        this.api.errorHandler(error, 'Failed get Amenity Reports');
                    }
                ),
                filter(({finished}) => finished),
                tap(
                    () => {
                        if (this.amenityInAmenityModal && this.view == 'calendar') {
                            const refreshedAmenityInAmenityModal = this.data[tabId].data.find((item) => this.amenityInAmenityModal.id == item.id);
                            if (refreshedAmenityInAmenityModal) {
                                this.getBookingInfoById(refreshedAmenityInAmenityModal.id).subscribe(res => {
                                    this.amenityInAmenityModal = Object.assign(this.amenityInAmenityModal, res);
                                })
                            }
                        }
                        if (this.selectedItemData) {
                            // this.toggleDetailedView(this.selectedItemData, true);
                            this.showDetailedView = false;
                            const selectedBooking = this.data.allAmenities.data.find(si => si.id == this.selectedItemData.id) ;
                            if (selectedBooking) {
                                this.getBookingInfoById(selectedBooking.id).subscribe(res => {
                                    this.showDetailedView = true;
                                    this.selectedItemData = Object.assign(this.selectedItemData, {});
                                    this.selectedItemData.checked = true;
                                })
                                //this.onDetailedViewToggle.emit();
                            }
                        } else {
                            this.showDetailedView = false;
                        }
                    }
                )
            );
    }

    bookingsFactory(entities: any, targetArray) {
        entities.forEach(booking => targetArray.push(Amenity.fromBookingData(booking)));
    }

    getBuildings(): void {
        this.buildings = [];
        if (this.authenticationService.userIsResident) {
            this.buildings.push({
                id: this.residentService.selectedBuilding.buildingId,
                name: this.residentService.selectedBuilding.buildingName
            });
        } else {
            const url = `/v1/building_defined_amenity.json?per-page=1000&order-by=buildingName|asc`;
            this.api.get('domainAmenities', url).subscribe(
                (res) => {
                    if (res._body && JSON.parse(res._body).length) {
                        JSON.parse(res._body).filter((building) => {
                            if (building.buildingId && building.buildingName) {
                                this.buildings.push({
                                    id: building.buildingId,
                                    name: building.buildingName,
                                    timezone: building.timeZone
                                });
                            }
                        });
                    }
                    this.getFilteredBuildings();
                },
                (error) => this.api.errorHandler(error, 'Failed get buildings')
            );
        }
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
        this.showDetailedView = false;
        this.selectedItemData = null;
    }

    getBookingInfoById(bookingId) {
        this.spinnerShow = true;
        this.calendarSpinnerShow = true;
        const url = `/v1/booking/${bookingId}.json?expand=amenity,building,suite,resident,createdBy,notes,notes.createdBy,payments,payments.transactions,payments.transactions.createdBy,event,event.bookings,event.bookings.suite,event.bookings.resident`;
        return this.api.getJson('domainAmenities', url).pipe(
            map((res) => {
                res.notes.sort((a: any, b: any) => {
                    if (new Date(a.createdAt) < new Date(b.createdAt)) {
                        return 1;
                    } else if (new Date(a.createdAt) > new Date(b.createdAt)) {
                        return -1;
                    } else {
                        return 0;
                    }
                });
                const parsedBooking = [];
                const booking = [res];
                booking.map(item => {
                    if (item.building && item.building.bdId) return item.building.id = item.building.bdId;
                });
                this.account.addEntitiesPermissions(booking, this.serviceName);
                this.bookingsFactory(booking, parsedBooking);

                return parsedBooking[0];
            }),
            tap(_ => {
                this.calendarSpinnerShow = false;
                this.spinnerShow = false;
            }));
    }

    editAmenity(amenity: Amenity) {
        this.getBookingInfoById(amenity.id).subscribe(res => {
            this.isAmenityModalShow = true;
            this.amenityInAmenityModal = Object.assign({}, res);
        });
    }

    showDepositChargeModal(amenity: Amenity) {
        this.getBookingInfoById(amenity.id).subscribe(res => {
            this.isAmenityDepositChargeShow = true;
            this.amenityInAmenityModal = Object.assign({}, res);
        });
    }

    showPaymentModal(amenity: Amenity) {
        this.getBookingInfoById(amenity.id).subscribe(res => {
            this.isAmenityPaymentShow = true;
            this.amenityInAmenityModal = Object.assign({}, res);
        });
    }

    deleteAmenity(id: number): void {
        if (!id) return;
        swal(ConstantsService.getSwalConfig('Delete Amenity Booking'),
            () => {
                const url = `/v1/booking/${id}.json`;
                this.api.remove('domainAmenities', url).subscribe(
                    () => {
                        toastr.success('Amenity Booking has been deleted.');
                        if (this.data.allAmenities.data.length - 1 == 0 && this.urlService.queryParams.page != '1')
                            this.urlService.queryParams.page = (parseInt(this.urlService.queryParams.page) - 1).toString();
                        this.getData();
                        if (this.view == 'calendar') {
                            if (this.authenticationService.userIsResident)
                                this.getAmenitiesForCalendarResident();
                            else
                                this.getAmenitiesForCalendar();
                        }
                    },
                    (error) => {
                        const body = JSON.parse(error._body);
                        let errorMessage = 'Delete Amenity Booking failed';
                        if (body && body.message) {
                            if (body.message === 'You can\'t delete a booking with paid payments')
                                errorMessage = 'Paid booking cannot be deleted before a refund(s) was issued. Please go to the \'payment\' menu and issue the refund(s).';
                            // else
                            //     errorMessage = body.message;
                        }
                        this.api.errorHandler(error, errorMessage);
                    }
                );
            }
        );
    }

    getPDF(id: number): void {
        if (!id) return;
        const url = `/v1/incident-reports-pdf/${id}.json`;
        this.api.get('domainIncidentReports', url).subscribe(
            (res) => {
                const pdfUrl = JSON.parse(res._body).path;
                const _src = `https://docs.google.com/viewer?url=${pdfUrl}&embedded=true`;
                window.open(_src);
            },
            (error) => this.api.errorHandler(error, 'View Pdf operation failed')
        );
    }

    canEdit(buildingId?: number) {

        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {

        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead = this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
    }

    getAmenitiesList(): void {
        const residentInfo = `&building_id=${this.residentService.selectedBuilding.buildingId}`;
        const residentBuilding = this.residentService.selectedBuilding.buildingId;
        const url = `/v1/amenity?expand=buildingAmenity,fees,residentOccupancyTypes&enable_status=1${residentBuilding ? residentInfo : ''}`;

        this.api.get('domainAmenities', `${url}`).subscribe(
            (res) => {
                const body = JSON.parse(res._body);
                const entities = body.entities;
                this.amenitiesList = [];
                entities.map(item => {
                    this.amenitiesList.push(item);
                });
                this.spinnerShow = false;
            },
            (error) => this.api.errorHandler(error, 'Failed get Amenity List')
        );
    }

    getAmenitiesListByBuilding(buildingId): void {
        this.modalAmenitiesLoadingSpinnerShow = true;
        this.amenitiesListForModal = [];
        // this.amenitiesByBuilding = [];
        this.eventsByBuilding = [];
        const residenntInfo = this.residentService.selectedBuilding.buildingId;
        const url = `/v1/amenity?expand=buildingAmenity,fees,events,events.bookings&enable_status=1&per-page=1000&building_id=${residenntInfo || buildingId}`;
        this.api.get('domainAmenities', `${url}`).subscribe(
            (res) => {
                this.amenitiesByBuilding = [];
                const body = JSON.parse(res._body);
                const entities = body.entities;
                const amenitiestoChooseFromArray = [];
                entities.map(item => {
                    if (!this.authenticationService.userIsResident || (this.authenticationService.userIsResident && item.allowResidentsToBook))
                        amenitiestoChooseFromArray.push(item);
                });
                this.amenitiesByBuilding = JSON.parse(JSON.stringify(amenitiestoChooseFromArray));
                while (amenitiestoChooseFromArray.length) {
                    this.amenitiesListForModal.push(amenitiestoChooseFromArray.splice(0, 3));
                }

                this.eventsByBuilding = [];
                this.amenitiesByBuilding.forEach(a => {
                    if (a.events)
                        this.eventsByBuilding = this.eventsByBuilding.concat(a.events.map(e => ({
                            ...e,
                            amenityImage: a.amenityImage,
                            amenityName: a.name,
                            eventId: e.id,
                            isEvent: true
                        })));
                });
                this.modalAmenitiesLoadingSpinnerShow = false;
            },
            (error) => this.api.errorHandler(error, 'Failed get Amenity List For Booking')
        );
    }

    getEventsListParsed(calendarBookings): Array<any> {
        const formated = [];
        calendarBookings.filter((booking) => {
            let title = '';
            if (!booking.isEvent)
                title = booking.suiteNumber + ' - ' + booking.amenityName;
            else {
                title = booking.amenityName + ' - ' + booking.event.name + '(' + booking.event.bookings.length;
                if (booking.event.maxNumberOfBookings)
                    title += '/' + booking.event.maxNumberOfBookings + ')';
                else
                    title += ')';
            }
            formated.push({
                title: title,
                start: new Date(booking.dateFrom).toISOString(),
                end: new Date(booking.dateTo).toISOString(),
                backgroundColor: this.getAmenityColorFromAmenityList(booking),
                borderColor: this.getAmenityColorFromAmenityList(booking),
                className: booking.status,
                id: booking.id,
                booking: booking
            });
        });
        return formated;
    }

    getAmenityNameFromAmenityList(booking): string {
        let amenityName = '';
        this.amenitiesList.filter((amenity) => {
            if (amenity.id == booking.amenityId)
                amenityName = booking.amenityName;
        });
        return amenityName;
    }

    getAmenityColorFromAmenityList(booking): string {
        let amenityColor = '#1ab394';
        this.amenitiesList.filter((amenity) => {
            if (amenity.id == booking.amenityId)
                amenityColor = amenity.amenityColor;
        });
        return amenityColor;
    }

    getAmenitiesForCalendarResident() {
        if (!this.residentService.selectedBuilding.buildingId)
            return;
        const monthChangedTo = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[0]);
        const yearChangedTo = parseInt((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[1]);
        const startDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, 1).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        this.arrayOfMonthsLastDays[1] = yearChangedTo % 4 == 0 ? 29 : 28;
        const endDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, this.arrayOfMonthsLastDays[monthChangedTo], 23, 59).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        this.calendarSpinnerShow = true;
        const query = this.urlService.queryParams['query'] ? `&query=*${this.urlService.queryParams['query']}*` : '';
        const amenityId = this.urlService.queryParams['amenity_id'] ? `&${this.urlService.getAmenityIdQueryString(this.urlService.queryParams['amenity_id'])}` : '';
        const selectedBuilding = `&building_id=${this.residentService.selectedBuilding.buildingId}&suite_id=${this.residentService.selectedBuilding.suite_id}`;
        const url = `/v1/calendar_view.json?bookingDateFrom=>=+${startDateForSending.toISOString()}&bookingDateTo=<=+${endDateForSending.toISOString()}${query}${amenityId}${this.residentService.selectedBuilding ? selectedBuilding : ''}`;

        this.api.get('domainAmenities', `${url}`).subscribe(
            (res) => {
                this.calendarBookings = [];
                this.eventsForCalendar = [];
                const body = JSON.parse(res._body);
                if (body && body.entities && body.entities.length > 0) {
                    this.eventsForCalendar = body.entities.map(item => ({
                        title: item.title,
                        start: new Date(item.start).toISOString(),
                        end: new Date(item.end).toISOString(),
                        backgroundColor: item.amenityColor,
                        borderColor: item.amenityColor,
                        className: item.currentUserBooking ? item.status : 'not-available',
                        id: item.id,
                        currentUserBooking: item.currentUserBooking
                    }));
                }
                if (this.amenityInAmenityModal && this.view == 'calendar') {
                    this.getBookingInfoById(this.amenityInAmenityModal.id).subscribe(res => {
                        this.amenityInAmenityModal = Object.assign(this.amenityInAmenityModal, res);
                    })
                    // this.calendarBookings.filter((item) => {
                    //     if (this.amenityInAmenityModal.id == item.id)
                    //         this.amenityInAmenityModal = Object.assign({}, item);
                    // });
                }
                this.calendarSpinnerShow = false;
                // Added the resize event, because the spinner does not disappear, until the mouse is hovered
                window.dispatchEvent(new Event('resize'));
                this.getDisabledDatesForCalendar(startDateForSending, endDateForSending);
            },

            (error) => this.api.errorHandler(error, 'Failed get Amenity Reports')
        );
    }

    getAmenitiesForCalendar(): void {
        if (this.view != 'calendar') return;
        this.calendarSpinnerShow = true;
        if (this.calendarViewRequestSubscription)
            this.calendarViewRequestSubscription.unsubscribe();
        if (this.amenitiesList.length) {
            const monthChangedTo = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[0]);
            const yearChangedTo = parseInt((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[1]);
            const startDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, 1).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
            this.arrayOfMonthsLastDays[1] = yearChangedTo % 4 == 0 ? 29 : 28;
            const endDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, this.arrayOfMonthsLastDays[monthChangedTo], 23, 59).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
            const url = `/v1/booking_list.json?expand=amenity,building,suite,event,payments&bookingDateFrom=>= ${startDateForSending.toISOString()}&bookingDateTo=<= ${endDateForSending.toISOString()}`;
            const queryParams = this.urlService.getQueryParamsString();
            const leftPart = '&page=1&per-page=1000';
            const rightPart = queryParams.split('per-page=')[1].split('&');
            // TODO:  rightPartString = '&' + queryParams.split('&').map(e => e.split('=')).filter(e => e[0] && !~['per-page', 'order-by'].indexOf(e[0])).map(e => e.join('=')).join('&')
            let rightPartString = '';
            if (rightPart.length > 1) {
                for (let i = 1; i < rightPart.length; i++) {
                    rightPartString += '&' + rightPart[i];
                }
            }
            const sortedByBuilding = `&building_id=${this.residentService.selectedBuilding.buildingId}&suite_id=${this.residentService.selectedBuilding.suite_id}`;
            const queryParams1000PerPage = leftPart + rightPartString;
            this.calendarViewRequestSubscription = this.api.getInfiniteList('domainAmenities', `${url}${rightPartString}${this.residentService.selectedBuilding.buildingId ? sortedByBuilding : ''}`, 500).subscribe(
                (body) => {

                    this.calendarBookings = [];
                    this.eventsForCalendar = [];
                    // const body = JSON.parse(res._body);
                    const entities = body.entities;
                    const calendarBookings = [];
                    this.emptyRowService.fillEmptyRow();
                    entities.map(item => {
                        if (item.building && item.building.bdId) return item.building.id = item.building.bdId;
                    });
                    this.account.addEntitiesPermissions(entities, this.serviceName);
                    this.bookingsFactory(entities, calendarBookings);
                    this.calendarBookings = calendarBookings;
                    this.eventsForCalendar = this.getEventsListParsed(this.calendarBookings);
                    if (this.amenityInAmenityModal && this.view == 'calendar') {
                        this.getBookingInfoById(this.amenityInAmenityModal.id).subscribe(res => {
                            this.amenityInAmenityModal = Object.assign({}, res);
                        })
                        // this.calendarBookings.filter((item) => {
                        //     if (this.amenityInAmenityModal.id == item.id)
                        //         this.amenityInAmenityModal = Object.assign({}, item);
                        // });
                    }
                    this.calendarSpinnerShow = false;
                    // Added the resize event, because the spinner does not disappear, until the mouse is hovered
                    window.dispatchEvent(new Event('resize'));
                    this.getDisabledDatesForCalendar(startDateForSending, endDateForSending);
                    this.getCalendarHiddenBookings();
                },
                (error) => this.api.errorHandler(error, 'Failed get Amenity Reports')
            );
        } else
            this.updateAmenitiesAndBookings();
    }

    updateAmenitiesAndBookings(): void {
        const monthChangedTo = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[0]);
        const yearChangedTo = parseInt((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[1]);
        const startDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, 1).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        const endDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, this.arrayOfMonthsLastDays[monthChangedTo], 23, 59).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        const url = `/v1/booking_list.json?expand=amenity,building,suite,resident,createdBy,notes,notes.createdBy,payments,payments.transactions,payments.transactions.createdBy,event&bookingDateFrom=>= ${startDateForSending.toISOString()}&bookingDateTo=<= ${endDateForSending.toISOString()}`;
        const queryParams = this.urlService.getQueryParamsString();
        const leftPart = '&page=1&per-page=1000';
        const rightPart = queryParams.split('per-page=')[1].split('&');
        let rightPartString = '';
        if (rightPart.length > 1) {
            for (let i = 1; i < rightPart.length; i++) {
                rightPartString += '&' + rightPart[i];
            }
        }
        const queryParams1000PerPage = leftPart + rightPartString;
        this.calendarViewRequestSubscription = this.api.getInfiniteList('domainAmenities', `${url}${rightPart}`, 500).subscribe(
            (body) => {
                this.calendarBookings = [];
               // const body = JSON.parse(res._body);
                const entities = body.entities;
                const calendarBookings = [];
                this.emptyRowService.fillEmptyRow();
                entities.map(item => {
                    if (item.building && item.building.bdId) return item.building.id = item.building.bdId;
                });
                this.account.addEntitiesPermissions(entities, this.serviceName);
                this.bookingsFactory(entities, calendarBookings);
                this.calendarBookings = calendarBookings;

                const url = `/v1/amenity?expand=buildingAmenity,fees&enable_status=1`;
                this.api.get('domainAmenities', `${url}`).subscribe(
                    (res) => {
                        this.eventsForCalendar = [];
                        const body = JSON.parse(res._body);
                        const entities = body.entities;
                        this.amenitiesList = [];
                        entities.map(item => {
                            this.amenitiesList.push(item);
                        });
                        this.eventsForCalendar = this.getEventsListParsed(this.calendarBookings);
                        this.calendarSpinnerShow = false;
                        this.getDisabledDatesForCalendar(startDateForSending, endDateForSending);
                        this.getCalendarHiddenBookings();
                    },
                    (error) => this.api.errorHandler(error, 'Failed get Amenity List')
                );
            },
            (error) => this.api.errorHandler(error, 'Failed get Amenity Reports')
        );
    }

    updateAmenityColor(amenityId, color): void {
        this.amenitiesList.filter((amenity) => {
            if (amenity.id == amenityId) {
                amenity.amenityColor = color;
                this.eventsForCalendar = this.getEventsListParsed(this.calendarBookings);
                this.eventsForCalendar = this.eventsForCalendar.concat(this.disabledDatesArray);
                this.updateCalendarEventSource();
            }
        });
    }

    getDisabledDatesForCalendar(start, end) {
        if (this.calendarDisabledDatesSubscription) {
            this.calendarDisabledDatesSubscription.unsubscribe();
        }
        this.calendarDisabledDatesSubscription = this.getDisabledDates(start, end)
            .pipe(
                map(
                    body => body.entities.map(item => {
                        return {
                            title: item.amenityName + (!this.authenticationService.userIsResident ? ' - Blocked Time slot' : ''),
                            start: item.startDate,
                            amenityId: item.amenityId,
                            disabledDateId: item.id,
                            end: item.endDate,
                            note: item.note,
                            booking: {},
                            disabledDate: true,
                            backgroundColor: !this.authenticationService.userIsResident ? '#000000' : '#c0c0c0',
                            borderColor: !this.authenticationService.userIsResident ? '#000000' : '#c0c0c0'
                        };
                    })
                ),
                tap(disabledDates => {
                    this.disabledDatesArray = disabledDates;
                })
            )
            .subscribe(
                disabledDates => {
                    this.eventsForCalendar = [
                        ...this.eventsForCalendar,
                        ...disabledDates
                    ];
                    this.updateCalendarEventSource();
                }, error => this.api.errorHandler(error, 'Failed to get diabled dates for amenities in current month.')
            );
    }

    getDisabledDates(start: Date = null, end: Date = null, amenityId: string | number = null) {
        const url = `/v1/disabled_dates.json`;
        const params = [];
        if (start) {
            params.push(`filterDateFrom=>=${start.toISOString()}`);
        }
        if (end) {
            params.push(`filterDateTo=<=${end.toISOString()}`);
        }
        if (amenityId) {
            params.push(`amenity_id=${amenityId}`);
        }
        return this.api.getJson('domainAmenities', `${url}?${params.join('&')}`);
    }

    getCalendarHiddenBookingsForAmenity(amenityId) {
        const monthChangedTo = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[0]);
        const yearChangedTo = parseInt((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[1]);
        const startDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, 1).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        const endDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, this.arrayOfMonthsLastDays[monthChangedTo], 23, 59).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        const url = `/v1/booking_schedule.json?start_date=${startDateForSending.toISOString()}&end_date=${endDateForSending.toISOString()}&amenity_id=${amenityId}&result_type=date_from`;

        return this.api.get('domainAmenities', url);
    }

    getCalendarHiddenBookings() {
        if (this.hiddenBookingsSubscription)
            this.hiddenBookingsSubscription.unsubscribe();
        const observables = [];
        const filteredAmenities = this.urlService.queryParams.amenity_id;
        const list = this.amenitiesList.filter(a => !filteredAmenities ? true : filteredAmenities.indexOf(a.id.toString()) != -1)
            .filter(a => a.buildingAmenity.length > 1);
        list.forEach(item => observables.push(this.getCalendarHiddenBookingsForAmenity(item.id)));
        if (observables.length > 0) {
            this.hiddenBookingsSubscription = Observable.forkJoin(observables).subscribe(
                res => {
                    res.forEach(item => {
                        const body = JSON.parse((<any>item)._body);
                        body.forEach(i => {
                            i.bookings.forEach(b => {
                                if (!this.calendarBookings.find(c => c.id == b.id) &&
                                    !this.eventsForCalendar.find(c => c.id == b.id)) {
                                    this.eventsForCalendar.push({
                                        title: this.amenitiesList.find(a => (<any>item).url.split('&')[2].split('amenity_id=')[1] == a.id).name,
                                        start: new Date(b.start).toISOString(),
                                        end: new Date(b.end).toISOString(),
                                        backgroundColor: 'grey',
                                        borderColor: 'grey',
                                        className: 'not-available',
                                        id: b.id,
                                        currentUserBooking: false,
                                        hiddenBooking: true
                                    });
                                }
                            });
                        });
                    });
                    this.updateCalendarEventSource();
                }, error => this.api.errorHandler(error, 'Failed to get other building bookings.')
            );
        }
    }

    toggleDetailedView(data, state: boolean): void {
        this.data.allAmenities.data.forEach(item => item.checked = false);
        this.selectedItemData = data ? data : null;
        this.showDetailedView = state;
        if (this.selectedItemData) {
            this.selectedItemData.checked = true;
            this.selectedItemData.notes.sort((a: any, b: any) => {
                if (new Date(a.createdAt) < new Date(b.createdAt)) {
                    return 1;
                } else if (new Date(a.createdAt) > new Date(b.createdAt)) {
                    return -1;
                } else {
                    return 0;
                }
            });
            this.getHistory();
            this.onDetailedViewToggle.emit();
            // for (const field in this.selectedItemData.formFields)
            //     this.selectedItemData.formFields[field].editMode = false;
        }
    }

    getHistory() {
        if (this.selectedItemData) {
            this.historyLoading = true;
            const url = `/v1/history.json?per-page=10000&objectId=${this.selectedItemData.id}`;
            this.api.get('domainAmenities', url).subscribe(
                (res) => {
                    this.historyLoading = false;
                    this.history = JSON.parse(res._body).entities;
                },
                (error) => {
                    this.historyLoading = false;
                    this.api.errorHandler(error, 'Failed to get History');
                }
            );
        }
    }

    viewAmenity(booking): void {
        this.amenityInAmenityModal = booking;
        this.isAmenityViewShow = true;
    }

    allPaymentArePaid(item): boolean {
        let allPaid = true;
        if (item.payments && item.payments.length > 0) {
            item.payments.filter((payment) => {
                if (payment.chosen && !payment.status && !payment.waived)
                    allPaid = false;
            });
        }
        return allPaid;
    }

    bookingHasPayments(item): boolean {
        let allPaid = true;
        if (!item.payments || item.payments.length < 1)
            allPaid = false;
        return allPaid;
    }

    approveBooking(item): void {
        if (this.allPaymentArePaid(item)) {
            let transitionStatus = '';
            if (item.status == 'pending')
                transitionStatus = 'approved';
            else if (item.status == 'declined')
                transitionStatus = 'declined_approved';
            const url = `/v1/booking/transit/${item.id}.json`;
            this.api.patch('domainAmenities', url, {transition: transitionStatus}).subscribe(
                () => this.updateView('Status was successfully updated'),
                error => this.api.errorHandler(error, 'Status update failed!')
            );
        } else
            toastr.warning('All payments must be paid before you can confirm the booking.');
    }

    declineBooking(item): void {
        let transitionStatus = '';
        if (item.status == 'pending')
            transitionStatus = 'declined';
        else if (item.status == 'approved')
            transitionStatus = 'approved_declined';
        const url = `/v1/booking/transit/${item.id}.json`;
        this.api.patch('domainAmenities', url, {transition: transitionStatus}).subscribe(
            () => this.updateView('Status was successfully updated'),
            error => this.api.errorHandler(error, 'Status update failed!')
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.getData();
        this.getAmenitiesForCalendar();
    }

    updateCalendarEventSource() {
        const $ucCalendar = $('#ucCalendar');
        $ucCalendar.fullCalendar('removeEvents');
        $ucCalendar.fullCalendar('addEventSource', this.eventsForCalendar);
    }

    cleanCalendarEvents() {
        this.eventsForCalendar = [];
        this.updateCalendarEventSource();
    }

    sendPaymentLink(data) {
        this.api.post('domainAmenities', `/v1/booking/send_paylink/${data.id}`, {}).subscribe(
            res => toastr.success('Payment Link was send successfully'),
            error => this.api.errorHandler(error, JSON.parse(error._body).message)
        );
    }

    getAmenity(amenityId: number) {
        return this.api.getJson('domainAmenities', `/v1/amenity/${amenityId}.json`);
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/amenities.service.ts